module.exports = "/_next/static/Components/Solution/e5b0212db4fbb5092cd4d61080f3c4a2.png";